"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Span = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Span = _styledComponents.default.span.withConfig({
  componentId: "sc-1k8k9xg-0"
})(["width:100%;display:block;overflow:hidden;padding-left:4px;transition:0.2s all linear;font-size:12px;line-height:1.2;", ""], function (_ref) {
  var _ref$theme = _ref.theme,
      margin = _ref$theme.margin,
      color = _ref$theme.color,
      typography = _ref$theme.typography,
      status = _ref.status,
      floating = _ref.floating;
  return "\n    color: ".concat(color[status], ";\n    font-family: ").concat(typography.fontFamily[0], ";\n    position: ").concat(floating ? 'absolute' : 'relative', ";\n    margin-top: ").concat(margin.xxxs, ";\n  ");
});

exports.Span = Span;